import React from "react";
import ContentEditable, { ContentEditableEvent } from "react-contenteditable";
import { useAppState } from "../../state";
import { AtomInputAddTask } from "../atoms/AtomInputAddTask";
import { TaskType } from "./Types";

export const AddTask = () => {
  const [state, dispatch] = useAppState();
  const [newTask, setNewTask] = React.useState<TaskType>({
    id: -1,
    name: "",
    description: "",
    minutes: 0,
    active: false,
  });

  const handleDescriptionChange = (event: ContentEditableEvent) => {
    setNewTask((prevState) => ({ ...prevState, description: event.target.value }));
  };

  const handleMinutesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    if (!isNaN(Number(inputValue))) {
      setNewTask((prevState) => ({
        ...prevState,
        minutes: Number(event.target.value),
      }));
    }
  };

  return (
    <div className="grid grid-cols-10 p-6 border-dotted border-gray-200 rounded-lg shadow hover:bg-gray-100 ">
      <div className="bg-transparent"></div>
      <div className="col-span-9 bg-transparent">
        <div className="focus:outline-0 text-xl mr-auto bg-transparent">
          <AtomInputAddTask newTask={newTask} setNewTask={setNewTask}></AtomInputAddTask>
        </div>
        <ContentEditable
          html={newTask.description || ""}
          disabled={false}       // use true to disable editing
          onChange={handleDescriptionChange} // handle innerHTML change
          tagName='article' // Use a custom HTML tag (uses a div by default)
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              document.execCommand('insertLineBreak')
              event.preventDefault()
            }
          }}
          className="w-full bg-inherit border-none focus:outline-none resize-none whitespace-pre-line"
        />
        <div>
          <input
            className="bg-inherit border-none focus:outline-none"
            id="standard-basic"
            inputMode="numeric"
            pattern="[0-9]*"
            onChange={handleMinutesChange}
            value={newTask.minutes !== 0 ? newTask.minutes : ""}
          />
        </div>
      </div>
    </div>
  );
};
